import { 
    Form,
    redirect,
    useNavigation,
    useActionData
} from "react-router-dom"

export async function Loader(){
    // const response = await fetch(`${import.meta.env.VITE_API_URL}/verify`, {
    //     method: "GET",
    //     credentials: 'include',    
    // })
    // if(response.ok){
    //     throw redirect('/admin/posts')
    // }
    // return null
}


export async function Action({ request }: any) {
    const formData = await request.formData()
    
    const name = formData.get("name")
    const password = formData.get("password")
    try {
        const response = await fetch(`${import.meta.env.VITE_API_URL}/users`, {
            method: "POST",
            headers: {
                'Content-Type': "application/json",
            },
            credentials: 'include',
            body: JSON.stringify({"name": name, "password": password})
        })

        if (response.ok){
            return redirect("/admin/login")
        } else {
            const errorText = await response.text()
            return { error: errorText || "Login failed"}
        }
    } catch (err: any) {
        return { error: err.message || "Something went wrong"}
    }
}

export default function Register() {
    const actionData = useActionData()
    const navigation = useNavigation()

    return (
        <div className="container login">
            <h1>Register for an account</h1>
            {actionData?.error && <h4 className="red">{actionData.error}</h4>}
            <Form  method="post" className="login-form">
                <input
                    name="name"
                    type="name"
                    placeholder="Username"
                    required
                />
                <input
                    name="password"
                    type="password"
                    placeholder="Password"
                    required
                />
                <button disabled={navigation.state === "submitting"}>
                    {navigation.state === "submitting" ? "Registering..." : "Register"}
                </button>
            </Form>
        </div>
    )

}